module.exports = __webpack_public_path__ + "static/media/photo34.8d092e18.jpg";